import { RendererClassificationMethodType } from '../store/slices/sidebarMapFiltersSlice';

export type RendererClassificationMethodsType = {
  label: string;
  value: RendererClassificationMethodType;
};

export const RENDERER_CLASSIFICATION_METHODS: RendererClassificationMethodsType[] = [
  { label: 'Natural Breaks', value: 'natural-breaks' },
  { label: 'Equal Interval', value: 'equal-interval' },
  { label: 'Quantile', value: 'quantile' },
  // { label: 'Standard Deviation', value: 'standard-deviation' },
];
